import styled from "styled-components"
import Dropzone from "react-dropzone"
import {greys} from "@irati/ui/src/global/colors"
import {H4} from "@irati/ui/src/Headings"

export const StyledDropzone = styled(Dropzone)`
  width: 100%;
  margin-bottom: 20px;
  border: 2px dashed ${greys.mediumDark};
  border-radius: 3px;
  cursor: pointer;
`

export const StyledDropzoneContents = styled.div`
  display: flex;
  align-content: flex-start;
  width: 100%;
`

export const Img = styled.img`
  margin: 30px;
`

export const UnderlineStrong = styled.strong`
  text-decoration: underline;
`

export const StyledH4 = styled(H4)`
  margin: 0;
  text-align: left;
`

export const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const ErrorTextWrapper = styled.div`
  white-space: nowrap;
`
